module.exports = __webpack_public_path__ + "img/taketomi_2.00d726f2.jpg";